/** Shared units for recorded dashboard/chat measures; never infer values from formatted strings. */
export const analyticsMetricLabels: Record<string, string> = {
    spend: 'Spend', roas: 'ROAS', purchases: 'Purchases', revenue: 'Attributed revenue',
    ctr: 'CTR', cpc: 'CPC', cpm: 'CPM', leads: 'Leads', costPerLead: 'Cost per lead', cpp: 'Cost per purchase', aov: 'Average order value', impressions: 'Impressions', clicks: 'Clicks', reach:'Reach', frequency: 'Frequency', addToCart:'Add to cart', checkoutInitiated:'Checkouts initiated', conversionRate:'Purchase conversion rate',
};
export function formatAnalyticsMetric(metric: string, value: number | null | undefined, currency = 'USD', compact = false) {
    if (value == null || !Number.isFinite(value))
        return '—';
    const notation = compact ? 'compact' as const : 'standard' as const;
    if (['spend', 'revenue', 'cpc', 'cpm', 'cpp', 'costPerLead', 'aov'].includes(metric))
        return new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: compact ? 1 : 2, notation }).format(value);
    if (metric === 'roas')
        return `${value.toFixed(2)}x`;
    if (metric === 'ctr' || metric === 'conversionRate')
        return `${value.toFixed(2)}%`;
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: metric === 'frequency' ? 2 : 0, maximumFractionDigits: metric === 'frequency' ? 2 : 0, notation }).format(value);
}
